<template>
  <div class="wrapper">
    <div class="award-name">
      <div class="name">{{ finalText.title }}</div>
      <div class="fill-tip">请填写以下信息领奖</div>
    </div>
    <div class="form-item">
      <div class="label">收货信息</div>
      <div
        v-if="finalText && finalText.address"
        class="address-bd"
        @click="copyAddress"
      >
        <p>{{ finalText.name }}, {{ finalText.mobile }}</p>
        <p>{{ finalText.address }}</p>
      </div>
      <div class="right-bd position-r" @click="chooseAdress" v-else>
        <div class="text">请选择收货地址</div>
        <img
          class="right-arrow"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/0b288c3890a38b88153dc97cf8ba5b66.png"
        />
        <WxLink v-if="isWeixin && isMobile" :wxPath="wxPath + qid" />
      </div>
    </div>
    <div class="save-tips">
      注意：请填写正确的收货地址，确认填写后无法修改，发起人会根据所填写的地址发送奖品。
    </div>
    <div class="submit">
      <div class="submit-btn" @click="goBack">返回</div>
    </div>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <ImgDialog :src="settingSrc" />
    </van-popup>
  </div>
</template>
<script>
import {
  setShareInfo,
  isWeixin,
  isMobile,
  getWxUrl,
  getDetailWxCode
} from "@/utils/common";
import { Toast } from "vant";
import WxLink from "@/components/wxLink.vue";
import ImgDialog from "@/components/common/imgDialog.vue";
export default {
  data() {
    return {
      finalText: {},
      title: "",
      wxPath: "/pages/detail/detail?qid=",
      qid: "",
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      settingUrl: "",
      settingSrc: "",
      showVersionTip: false
    };
  },
  components: {
    WxLink,
    ImgDialog
  },
  methods: {
    async chooseAdress() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        if (!this.settingSrc) {
          this.settingSrc = await getDetailWxCode(this.qid);
        }
        this.showVersionTip = true;
      }
    },
    copyAddress() {
      let { name, mobile, address } = this.finalText;
      this.$copyText(name + ", " + mobile + "\n" + address);
      Toast("复制成功");
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.finalText = JSON.parse(localStorage.getItem("logistics"));
    this.qid = this.finalText.qid;
    setShareInfo(false);
  },
  destroyed() {
    localStorage.removeItem("logistics");
  }
};
</script>
<style lang="scss" scoped>
.header {
  margin: 10px 15px;
  font-size: 13px;
  line-height: 1.5;
  color: #666;
}

.form-item {
  background: #fff;
  font-size: 15px;
  color: #333;
  padding: 25px 15px;
  margin: 0 12.5px;
  border-radius: 10px;
}

.form-item .text {
  color: #999;
}

.right-bd {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f7f7f7;
  border-radius: 4px;
  margin-top: 15px;
}

.right-arrow {
  width: 8px;
  height: 12.5px;
  margin-left: 5px;
}

.address-bd {
  display: block;
  background: #fff;
  font-size: 13px;
  color: #999;
  margin-top: 15px;
  border-top: 1px solid #e0e0e0;
  padding-top: 15px;
}

.btn {
  margin: 15px auto 0;
  width: 345px;
  height: 45px;
  line-height: 45px;
  font-size: 15px;
  color: #fff;
  background: #1890ff;
  border-radius: 2px;
  text-align: center;
}

.award-name {
  padding: 40px 15px 0;
  text-align: center;
  font-size: 16px;
}

.tip {
  color: #a8071a;
  font-size: 14px;
  margin-top: 7.5px;
}

.fill-tip {
  padding: 20px 0;
  border-top: 1px dashed #cccccc;
  margin-top: 20px;
  color: #262626;
}

.save-tips {
  font-size: 14px;
  color: #999999;
  margin: 20px 12.5px;
}

.submit {
  height: 65px;
  border: 1px solid #eee;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  box-sizing: content-box;
  padding-bottom: env(safe-area-inset-bottom);
  min-width: 320px;
  max-width: 500px;
  margin: 0 auto;
  box-sizing: border-box;
}

.submit-btn {
  background: #a8071a;
  border-radius: 4px;
  font-size: 17px;
  color: #fff;
  text-align: center;
  height: 45px;
  line-height: 45px;
  flex: 1;
  margin: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/award/address.vue